const apiUrl = process.env.REACT_APP_API_URL;

export const GetAulaAdmins = async (idAula: string | number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${idAula}/admins`);
        if (!response.ok) return [];
        return await response.json();
    } catch (error) {
        console.error('Error fetching admins:', error);
        return [];
    }
};
